/**
* Results Slider JS
* -----------------------------------------------------------------------------
*
* All the JS for the Results Slider component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
import Splide from '@splidejs/splide';
( function( app ) {
  const COMPONENT = {

    className: 'results-slider',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      $( '.results-slider__splide' ).each( function( index, element ) {
        const slider = new Splide( $( element )[0], {
          type: 'loop',
          drag: false,
          arrows: true,
          pagination: false,
          focus: 'center',
          fixedWidth: '669px',
          gap: '2rem',
          breakpoints: {
            768: {
              fixedWidth: '345px',
            },
          },
        } );

        slider.on( 'overflow', function( isOverflow ) {
          slider.options = {
            arrows: isOverflow,
            drag: isOverflow,
          };
        } );
        slider.mount();
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'results-slider', COMPONENT );
} )( app );
